import { render, staticRenderFns } from "./WarnDialog.vue?vue&type=template&id=97372406&"
import script from "./WarnDialog.vue?vue&type=script&lang=js&"
export * from "./WarnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports